import { Image, SidebarModal } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import type { CampaignQuotePayload } from '@hooks/useCampaignQuote'

import type { DefaultState } from '@modals/NewCampaignQuoteModal'

import QuoteBlankImageUrl from './assets/quote-blank.svg'
import QuoteCampaignImageUrl from './assets/quote-campaign.svg'
import QuoteTemplateImageUrl from './assets/quote-template.svg'

interface DefaultScreenProps {
  callbacks: {
    afterAction: VoidFunction,
    closeModal: VoidFunction,
    createCampaignQuote: (params: HandleCallbackActionParams) => void,
    selectScreen: (key: DefaultState['selectedScreen']) => void,
  },
  campaignQuotePayload: CampaignQuotePayload,
  requestOptions?: object,
}

const DefaultScreen = (props: DefaultScreenProps) => {
  const {
    callbacks: {
      afterAction,
      createCampaignQuote,
      selectScreen,
    },
    campaignQuotePayload: {
      callbacks: { createCampaignQuote: createFn },
      campaignQuote,
      requiresTemplate,
    },
    requestOptions,
  } = props

  return (
    <SidebarModal.Content hasFooter={false}>
      <SidebarModal.Button
        iconLeft={(
          <Image
            backgroundSize="contain"
            height={30}
            width={30}
            url={QuoteTemplateImageUrl}
          />
        )}
        onClick={() => selectScreen('CreateFromTemplate')}
        showAngleIcon
        subtitle="Choose from saved templates"
        title="Use a Template"
      />

      {!requiresTemplate && (
        <>
          <SidebarModal.Button
            iconLeft={<Image backgroundSize="contain" height={30} width={30} url={QuoteCampaignImageUrl} />}
            onClick={() => selectScreen('CopyFromCampaign')}
            showAngleIcon
            subtitle="Copy quote from a campaign"
            title="From Existing Campaign"
          />

          <SidebarModal.Button
            iconLeft={<Image backgroundSize="contain" height={30} width={30} url={QuoteBlankImageUrl} />}
            onClick={() => createCampaignQuote({
              callbacks: {
                action: createFn,
                afterAction,
              },
              entityParams: campaignQuote,
              toastText: 'Campaign Quote Created',
              requestOptions,
            })}
            showAngleIcon
            subtitle="Start with a blank canvas"
            title="Empty Quote"
          />
        </>
      )}
    </SidebarModal.Content>
  )
}

export default DefaultScreen
